import http from 'hub-http/clients/apiClient';
import { addEmptyPropertyFilters } from './utils';
export async function performCRMSearch(context) {
  const {
    query
  } = context;
  if (!query) {
    throw new Error('No query provided');
  }
  const result = await http.post('/crm-search/search', {
    data: query
  });
  return result;
}
export async function performCRMSearchWithEmptyProperties(context, propertyNames) {
  const {
    query
  } = context;
  if (!query) {
    throw new Error('No query provided');
  }
  const queryWithEmptyProperties = addEmptyPropertyFilters(query, propertyNames);
  const result = await http.post('/crm-search/search', {
    data: queryWithEmptyProperties
  });
  return result;
}